/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionLead } from './PalAuthSubmissionLead';
import {
    PalAuthSubmissionLeadFromJSON,
    PalAuthSubmissionLeadFromJSONTyped,
    PalAuthSubmissionLeadToJSON,
    PalAuthSubmissionLeadToJSONTyped,
} from './PalAuthSubmissionLead';

/**
 * 
 * @export
 * @interface PalReauthSubmissionListEntryLeadExternalEhrPatient
 */
export interface PalReauthSubmissionListEntryLeadExternalEhrPatient {
    /**
     * 
     */
    patient_id?: string;
    /**
     * 
     */
    type?: PalReauthSubmissionListEntryLeadExternalEhrPatientTypeEnum;
    /**
     * 
     */
    details_push_date?: string;
    /**
     * 
     */
    details_extraction_date?: string;
    /**
     * 
     */
    is_extracting_details?: boolean;
    /**
     * 
     */
    leads?: Array<PalAuthSubmissionLead>;
    /**
     * 
     */
    is_screener_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_additional_document_upload_in_progress?: boolean;
    /**
     * 
     */
    is_generated_document_upload_in_progress?: boolean;
}


/**
 * @export
 */
export const PalReauthSubmissionListEntryLeadExternalEhrPatientTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH',
    Kinnser: 'KINNSER',
} as const;
export type PalReauthSubmissionListEntryLeadExternalEhrPatientTypeEnum = typeof PalReauthSubmissionListEntryLeadExternalEhrPatientTypeEnum[keyof typeof PalReauthSubmissionListEntryLeadExternalEhrPatientTypeEnum];


/**
 * Check if a given object implements the PalReauthSubmissionListEntryLeadExternalEhrPatient interface.
 */
export function instanceOfPalReauthSubmissionListEntryLeadExternalEhrPatient(value: object): value is PalReauthSubmissionListEntryLeadExternalEhrPatient {
    return true;
}

export function PalReauthSubmissionListEntryLeadExternalEhrPatientFromJSON(json: any): PalReauthSubmissionListEntryLeadExternalEhrPatient {
    return PalReauthSubmissionListEntryLeadExternalEhrPatientFromJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryLeadExternalEhrPatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionListEntryLeadExternalEhrPatient {
    if (json == null) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'] == null ? undefined : json['patient_id'],
        'type': json['type'] == null ? undefined : json['type'],
        'details_push_date': json['details_push_date'] == null ? undefined : json['details_push_date'],
        'details_extraction_date': json['details_extraction_date'] == null ? undefined : json['details_extraction_date'],
        'is_extracting_details': json['is_extracting_details'] == null ? undefined : json['is_extracting_details'],
        'leads': json['leads'] == null ? undefined : ((json['leads'] as Array<any>).map(PalAuthSubmissionLeadFromJSON)),
        'is_screener_document_upload_in_progress': json['is_screener_document_upload_in_progress'] == null ? undefined : json['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': json['is_additional_document_upload_in_progress'] == null ? undefined : json['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': json['is_generated_document_upload_in_progress'] == null ? undefined : json['is_generated_document_upload_in_progress'],
    };
}

export function PalReauthSubmissionListEntryLeadExternalEhrPatientToJSON(json: any): PalReauthSubmissionListEntryLeadExternalEhrPatient {
    return PalReauthSubmissionListEntryLeadExternalEhrPatientToJSONTyped(json, false);
}

export function PalReauthSubmissionListEntryLeadExternalEhrPatientToJSONTyped(value?: PalReauthSubmissionListEntryLeadExternalEhrPatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient_id': value['patient_id'],
        'type': value['type'],
        'details_push_date': value['details_push_date'],
        'details_extraction_date': value['details_extraction_date'],
        'is_extracting_details': value['is_extracting_details'],
        'leads': value['leads'] == null ? undefined : ((value['leads'] as Array<any>).map(PalAuthSubmissionLeadToJSON)),
        'is_screener_document_upload_in_progress': value['is_screener_document_upload_in_progress'],
        'is_additional_document_upload_in_progress': value['is_additional_document_upload_in_progress'],
        'is_generated_document_upload_in_progress': value['is_generated_document_upload_in_progress'],
    };
}

